import { AUTH0_MAJORCLARITY_COOKIE_NAME, MAJORCLARITY_AUTH_TOKEN_COOKIE } from './constants'
import { isEmpty, isString } from 'lodash'
import jsCookie from 'js-cookie'

const isFilledStr = (value: any): boolean => {
  if (!isString(value)) return false

  return !isEmpty(value.trim())
}

const isAuth0AuthenticatedMajorClarityUser = (): boolean => {
  return (
    isFilledStr(jsCookie.get(AUTH0_MAJORCLARITY_COOKIE_NAME)) ||
    isFilledStr(jsCookie.get(MAJORCLARITY_AUTH_TOKEN_COOKIE))
  )
}

export { isAuth0AuthenticatedMajorClarityUser, isFilledStr }
